import { Modal } from 'antd'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

import { useProfileStore } from '@/stores/user/profileStore'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import { ConstructionSiteInterface } from '@/types'
import api from '@/utils/api/api'
import { handleApiError } from '@/utils/api/errors/handleApiError'

import {
  getConstructionSiteUpdateRequestBody,
  getShortenConstructionSiteProperty,
} from './ConstructionSiteCard.config'
import cn from './ConstructionSiteCard.module.scss'

type ConstructionSitesCardPropsType = {
  constructionSite: ConstructionSiteInterface['constructionSiteModel']
  location: 'constructionSites' | 'constructionSitesArchive'
}

function ConstructionSiteCard(props: ConstructionSitesCardPropsType) {
  const { constructionSite, location } = props
  const { setUpdateConstructionSites } = useProfileStore((state) => state)
  const { organisation, selectedOrganisation } = useUserInfoStore(
    (state) => state
  )
  const navigate = useNavigate()
  const [modal, contextHolder] = Modal.useModal()

  const handleActionOnConstructionSite = (action: string) => {
    const orgId = selectedOrganisation?.id || organisation?.id
    if (!orgId) return

    const actionMessages: Record<string, { loading: string; success: string }> =
      {
        makeItMain: {
          loading: 'Установка основного...',
          success: 'Объект сделан основным',
        },
        sendToConstructionSitesArchive: {
          loading: 'Архивация...',
          success: 'Перенесено в архив',
        },
        sendToConstructionSites: {
          loading: 'Восстановление...',
          success: 'Объект восстановлен',
        },
      }

    const messages = actionMessages[action]
    const loadingToast = toast.loading(messages.loading)

    const payload = getConstructionSiteUpdateRequestBody(
      constructionSite,
      action === 'makeItMain',
      action !== 'sendToConstructionSitesArchive'
    )

    api
      .put(
        `/organisations/${orgId}/construction-sites/${constructionSite.id}`,
        payload
      )
      .then(() => {
        toast.success(messages.success, { id: loadingToast })
        setUpdateConstructionSites(true)
      })
      .catch((e) => {
        toast.dismiss(loadingToast)
        handleApiError(e, modal)
      })
  }

  // Определяем, основной это объект или склад
  const isPrimary = constructionSite.isMain || constructionSite.isStore

  return (
    <>
      {contextHolder}
      <div
        className={[
          cn.constructionSite,
          isPrimary ? cn.main : '',
          location === 'constructionSitesArchive' ? cn.archived : '',
        ].join(' ')}
        onClick={() => navigate(`/construction-sites/${constructionSite.id}`)}
      >
        <div className={cn.inner}>
          <p className={cn.title}>
            {constructionSite.description
              ? getShortenConstructionSiteProperty(
                  constructionSite.description,
                  20
                )
              : 'Без названия'}
          </p>

          <div className={cn.mainInfo}>
            <div className={cn.infoRow}>
              <span className={cn.label}>Адрес:</span>
              <span className={cn.value}>
                {constructionSite.address
                  ? getShortenConstructionSiteProperty(
                      constructionSite.address,
                      40
                    )
                  : '—'}
              </span>
            </div>
            <div className={cn.infoRow}>
              <span className={cn.label}>Телефон:</span>
              <span className={cn.value}>
                {constructionSite.ownerPhoneNumber || '—'}
              </span>
            </div>
            <div className={cn.infoRow}>
              <span className={cn.label}>Владелец:</span>
              <span className={cn.value}>
                {constructionSite.ownerName || '—'}
              </span>
            </div>
          </div>

          <div className={cn.footer} onClick={(e) => e.stopPropagation()}>
            <div className={cn.actionsColumn}>
              {location === 'constructionSites' ? (
                <>
                  {/* Склады нельзя архивировать, обычные объекты — можно */}
                  {!constructionSite.isStore && (
                    <button
                      className={cn.archiveBtn}
                      onClick={() =>
                        handleActionOnConstructionSite(
                          'sendToConstructionSitesArchive'
                        )
                      }
                    >
                      В архив
                    </button>
                  )}

                  {isPrimary ? (
                    <span className={cn.statusLabel}>
                      {constructionSite.isStore ? 'Основной склад' : 'Основной'}
                    </span>
                  ) : (
                    <button
                      className={cn.actionLink}
                      onClick={() =>
                        handleActionOnConstructionSite('makeItMain')
                      }
                    >
                      Сделать основным
                    </button>
                  )}
                </>
              ) : (
                <button
                  className={cn.actionLink}
                  onClick={() =>
                    handleActionOnConstructionSite('sendToConstructionSites')
                  }
                >
                  Восстановить
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConstructionSiteCard
